import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import ExamPage from "./pages/ExamPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SubmissionReview from "./pages/SubmissionReview";
import QuestionsManagement from "./pages/QuestionsManagement";
import UserManagement from "./pages/UserManagement";
import ReportsPage from "./pages/ReportsPage";
import AdminCandidates from "./pages/AdminCandidates";
import QuestionSets from "./pages/QuestionSets";
import ExamSettings from "./pages/ExamSettings";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAF9]">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/exam" element={<ExamPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/submission/:id" element={<SubmissionReview />} />
          <Route path="/admin/questions" element={<QuestionsManagement />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/reports" element={<ReportsPage />} />
          <Route path="/admin/candidates" element={<AdminCandidates />} />
          <Route path="/admin/question-sets" element={<QuestionSets />} />
          <Route path="/admin/exam-settings" element={<ExamSettings />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
